<template>
  <div v-if="hasValue">
    <hourRange v-model="hourRange" :readonly="readonly" />
    <v-btn
      v-if="hasHours && !readonly"
      color="success"
      rounded
      small
      @click="addBreak()"
    >
      <v-icon>mdi-pause-circle-outline</v-icon>
      Pausen
    </v-btn>
    <div class="mt-8 blue-grey--text text--lighten-1" v-for="(b, i) in value.breaks" :key="i">
      <strong>{{b.name}}:</strong>
      <div>
        {{b.from}}-{{b.to}}
        <v-btn text small color="error" @click="removeBreak(i)" v-if="!readonly">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showPauseDialog" :persistent="true" max-width="600px">
      <v-card v-if="showPauseDialog">
        <new-pause @cancel="showPauseDialog = false" @save="confirmBreakAdd" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import NewPause from './NewPause';
import HourRange from './HourRange';

export default {
  name: 'DayHours',
  props: {
    value: {
    },
    readonly: {
      type: Boolean,
    },
  },
  components: {
    HourRange,
    NewPause,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    hasValue() {
      return !!this.value;
    },
    hourRange: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', {...this.value, ...newValue});
      }
    },
    hasHours() {
      return this.value.from && this.value.to;
    },
  },
  methods: {
    confirmBreakAdd(newBreak) {
      this.showPauseDialog = false;
      this.$emit('input', {...this.value, breaks: [...this.value.breaks, newBreak]});
    },
    addBreak() {
      this.showPauseDialog = true;
    },
    removeBreak(i) {
      const breaks = [...this.value.breaks];
      breaks.splice(i, 1);

      this.$emit('input', {...this.value, breaks});
    },
  },
  data() {
    return {
      showPauseDialog: false,
    };
  },
};
</script>
